import { partnerServices } from "../../config/axios";
import MyVouchers from "../../views/Vouchers/MyVouchers/MyVouchers";
import {
  GETWALLETTRANSACTIONLIST_SUCCESS,
  GETWALLETTRANSACTIONLIST_FAILED,
  RESET_GETWALLETTRANSACTIONLIST,
  LOADING_GETWALLETTRANSACTIONLIST,
  NETWORK_ERROR_GETWALLETTRANSACTIONLIST,
} from "../types";

function resetGetWalletTransactionList() {
  return {
    type: RESET_GETWALLETTRANSACTIONLIST,
  };
}

const getWalletTransactionList = (data, authTokenIs) => async (dispatch) => {
  const authToken = sessionStorage.getItem("authToken") || authTokenIs;

  dispatch({
    type: LOADING_GETWALLETTRANSACTIONLIST,
  });

  await partnerServices
    .post("getWalletTransactionList", data, { headers: { AuthToken: authToken } })
    .then((res) => {
      switch (res.status) {
        case 400:
          dispatch(getWalletTransactionListFailed(res.data));
          break;
        case 200:
          dispatch(getWalletTransactionListSuccess(res.data));
          break;
        default:
          dispatch(getWalletTransactionListFailed());
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETWALLETTRANSACTIONLIST, payload: err });
    });
};
function getWalletTransactionListFailed(data) {
  return {
    type: GETWALLETTRANSACTIONLIST_FAILED,
    payload: data,
  };
}
function getWalletTransactionListSuccess(data) {
  return {
    type: GETWALLETTRANSACTIONLIST_SUCCESS,
    payload: data,
  };
}

export { getWalletTransactionList, resetGetWalletTransactionList };